/** Pull-to-sync decisions are independent of rendering and the network. */
export const PULL_SYNC_THRESHOLD_PX = 64;
// Ignore small finger wobble before deciding whether a pull owns the gesture.
export const PULL_AXIS_SLOP_PX = 10;
export type PullAxis = "pending" | "vertical" | "cancelled";
export function pullAxis(dx: number, dy: number, previous: PullAxis): PullAxis {
  if (previous !== "pending") return previous;
  if (Math.max(Math.abs(dx), Math.abs(dy)) < PULL_AXIS_SLOP_PX) return "pending";
  return dy > Math.abs(dx) ? "vertical" : "cancelled";
}
export function pullArmed(distance: number): boolean { return distance >= PULL_SYNC_THRESHOLD_PX; }
export function pullRelease(axis: PullAxis, distance: number, cancelled: boolean): boolean {
  return !cancelled && axis === "vertical" && pullArmed(distance);
}
